<template>
    <div class="page" element-loading-background="rgba(0, 0, 0, 0)" element-loading-text="加载中" v-loading="loading">
        <div class="title">节点拓扑图</div>
        <div id="chart" ref="chart"></div>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    import worldData from "./json/china.json";
    echarts.registerMap("china", worldData);
    import axios from '@/axios/index'
    import * as moment from 'moment'
    import * as math from 'mathjs'
    moment.locale("zh-cn")
    export default {
        components: {},
        data() {
            return {
                loading: false,
                chart: null
            }
        },
        methods: {
            async getData() {
                // let response = await axios.request({
                //     url: "/api/dataworks.super/super_display",
                //     method: "GET",
                //     params: {
                //         name: 'china'
                //     }
                // })
                let response = { "code": 200, "msg": "获取成功", "time": 1663226360, "data": { "name": "super_display_china", "desc": { "stat_01": "头部数据", "stat_02": "地图数据", "stat_03": "尾部数据" }, "refresh": 300, "data": { "stat_01": { "region_count": "25", "refresh_interval": "5" }, "stat_02": [{ "city": "厦门市", "gps": ["118.147028", "24.489354"], "data": [{ "city": "北京市", "gps": ["116.404188", "39.914466"], "value": "1078" }, { "city": "天津市", "gps": ["117.207516", "39.091551"], "value": "183" }, { "city": "河北省", "gps": ["114.521646", "38.049565"], "value": "113" }, { "city": "山西省", "gps": ["112.556153", "37.878008"], "value": "112" }, { "city": "内蒙古自治区", "gps": ["111.753059", "40.846736"], "value": "92" }, { "city": "辽宁省", "gps": ["123.436744", "41.815235"], "value": "134" }, { "city": "上海市", "gps": ["121.481115", "31.235929"], "value": "3057" }, { "city": "江苏省", "gps": ["118.800024", "32.065308"], "value": "1172" }, { "city": "浙江省", "gps": ["120.189433", "30.290511"], "value": "6080" }, { "city": "安徽省", "gps": ["117.305818", "31.717586"], "value": "223" }, { "city": "福建省", "gps": ["119.303021", "26.081421"], "value": "1899" }, { "city": "江西省", "gps": ["115.862529", "28.688788"], "value": "155" }, { "city": "山东省", "gps": ["117.122303", "36.654477"], "value": "271" }, { "city": "河南省", "gps": ["113.751906", "34.753683"], "value": "384" }, { "city": "湖北省", "gps": ["114.30015", "30.602342"], "value": "239" }, { "city": "广东省", "gps": ["113.267252", "23.134227"], "value": "635" }, { "city": "广西壮族自治区", "gps": ["108.370742", "22.8234"], "value": "217" }, { "city": "重庆市", "gps": ["106.554413", "29.568493"], "value": "126" }, { "city": "四川省", "gps": ["104.072888", "30.582021"], "value": "427" }, { "city": "贵州省", "gps": ["106.640884", "26.650019"], "value": "26" }, { "city": "云南省", "gps": ["102.78656", "24.98398"], "value": "1761" }, { "city": "陕西省", "gps": ["108.948891", "34.346415"], "value": "93" }, { "city": "甘肃省", "gps": ["103.838224", "36.0678"], "value": "18" }, { "city": "青海省", "gps": ["101.784733", "36.62067"], "value": "6" }, { "city": "香港特别行政区", "gps": ["114.172893", "22.28293"], "value": "2770" }] }], "stat_03": { "partner_count": "138", "users_count": "4万", "report_count": "42万次", "devices_count": "21,271" } } } }
                let { stat_01 = {}, stat_02 = [], stat_03 = {}, refresh = 300 } = response.data.data
                stat_02.forEach(item => {
                    item.value = 0
                    item.gps = [parseFloat(item.gps[0]), parseFloat(item.gps[1])]
                    item.data.forEach(item1 => {
                        item1.gps = [parseFloat(item1.gps[0]), parseFloat(item1.gps[1])]
                        item1.value = parseFloat(item1.value)
                        item.value += parseFloat(item1.value)
                    })
                })
                this.stat_02 = stat_02
                this.setEcharts()
            },
            setEcharts() {
                let rldData = [] // 热力点数据
                let endData = [] //到达点数据
                let stat_02 = this.stat_02
                stat_02.forEach(item => {
                    item.data.forEach(item1 => {
                        rldData.push({
                            name: item1.city,
                            value: [item1.gps[0], item1.gps[1], item1.value]
                        })
                        endData.push({
                            name: item1.city,
                            value: item1.gps
                        })
                    })
                })

                let series = [
                    { // 结束点
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        zlevel: 0,
                        symbolSize: 40,
                        symbol: 'image://' + require('@/assets/image/gps.png'),
                        data: endData
                }
            ];
                // 动态加路径  实现每个组颜色不同
                for (let i = 0; i < stat_02.length; i++) {
                    let item = stat_02[i];
                    let luJingData = [] //路径数据
                    let itemValue = 0 //一共多少
                    for (let ii = 0; ii < item.data.length; ii++) {
                        let item1 = item.data[ii];
                        luJingData.push({
                            fromName: item.city,
                            toName: item1.city,
                            coords: [item.gps, item1.gps],
                            value: item1.value
                        })
                        itemValue += item1.value
                    }

                    series.push({ //线 路径
                        type: 'lines',
                        zlevel: 1,
                        symbol: ['none', 'none'], //两端标记
                        // effect: {
                        //     show: true,
                        //     period: 5,
                        //     trailLength: 0,
                        //     symbol: planePath,
                        //     symbolSize: 15
                        // },
                        lineStyle: {
                            normal: {
                                color: "#1ECDA4",
                                width: 1,
                                opacity: 1,
                                curveness: 0.1 //边的曲度，支持从 0 到 1 的值，值越大曲度越大。
                            }
                        },
                        data: luJingData
                    })

                    series.push({ //线 动画
                        type: 'lines',
                        zlevel: 2,
                        symbol: ['none', 'none'], //两端标记
                        effect: {
                            show: true,
                            period: 10, //特效动画的时间，单位为 s。
                            trailLength: 0, //特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
                            color: "#1ECDA4",
                            symbolSize: 7.5 //特效标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示高和宽，例如 [20, 10] 表示标记宽为20，高为10。
                        },
                        lineStyle: {
                            normal: {
                                width: 0,
                                curveness: 0.1 //边的曲度，支持从 0 到 1 的值，值越大曲度越大。
                            }
                        },
                        data: luJingData
                    })

                    series.push({ //起始点
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        zlevel: 0,
                        symbolSize: 40,
                        symbol: 'image://' + require('@/assets/image/gps.png'),
                        data: [{
                            name: item.city,
                            value: [].concat(item.gps).concat([itemValue])
                        }],
                    })
                }
                this.chart = echarts.init(this.$refs.chart);
                this.chart.setOption({
                    tooltip: {
                        show: true
                    },
                    grid: {
                        width: '100%',
                        height: '100%',
                        // left: '0%',
                        // right: '0%',
                        // bottom: '0%',
                        // top:'10%',
                        containLabel: true
                    },
                    // layoutCenter: ['70%', '50%'], //位置
                    // layoutSize: '65%', //大小
                    geo: {
                        width: '100%',
                        top: '5%',
                        tooltip: {
                            trigger: 'item',
                            formatter: function(params, ticket, callback) { return }
                        },
                        name: '世界地图',
                        type: 'map',
                        map: 'china',
                        label: {
                            emphasis: {
                                show: true,
                                color: '#fff'
                            }
                        },
                        // roam: true, //支持拖拽缩放
                        // scaleLimit: { //滚轮缩放的极限控制
                        //     min: 0.5, //缩放最小大小
                        //     max: 6, //缩放最大大小
                        // },
                        itemStyle: {
                            normal: {
                                borderWidth: 1, //边际线大小
                                // borderColor: 'red', //边界线颜色
                                areaColor: '#F0F3F2', //默认区域颜色
                                borderColor: '#D8DEDE'
                            },
                            emphasis: {
                                show: true,
                                // areaColor: '#2a333d'
                                areaColor: '#1ecda4', //鼠标滑过区域颜色
                                label: {
                                    show: true,
                                    textStyle: {
                                        color: '#fff'
                                    }
                                }
                            }
                        }
                    },
                    series
                })
            },
        },
        async mounted() {
            this.loading = true
            await this.getData()
            this.loading = false
        },
        destroyed() {
            if (this.chart) this.chart.dispose()
        }

    }
</script>

<style scoped lang="less">
    .page {
        height: calc(100vh - 128px);
        display: flex;
        flex-direction: column;
    }

    .title {
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        padding-top: 32px;
        flex-shrink: 0;
    }

    #chart {
        width: 100%;
        flex: auto;
    }
</style>